import { useSnackbar } from 'notistack'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ContractorPortalLogout, Logout } from 'src/constants/actionTypes'
import { PARTNER_DISABLED_ERROR } from 'src/constants/auth'
import { CONTRACTOR_PORTAL_ROUTES, CLIENT_ROUTES } from 'src/constants/routes'
import { createAsyncAction, Action } from 'src/utils/reduxUtils'
import { formatApiErrorMessage } from 'src/utils/errorHandlers'

export const useAsyncDispatchWithErrorToast = (platform: 'client' | 'contractorPortal') => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const snackbar = useSnackbar()

  const asyncDispatchWithErrorToast = useCallback(
    async <T, K = any>(action: Action<K>, silent?: boolean): Promise<T | null> => {
      try {
        const result = await createAsyncAction<T, K>(dispatch, action)

        return result
      } catch (err: any) {
        if (err === PARTNER_DISABLED_ERROR) {
          if (platform === 'client') {
            dispatch(Logout.request())
            setTimeout(() => {
              navigate(CLIENT_ROUTES.PARTNER_DISABLED_URL)
            }, 300)
          }

          if (platform === 'contractorPortal') {
            dispatch(ContractorPortalLogout.request())
            setTimeout(() => {
              navigate(CONTRACTOR_PORTAL_ROUTES.PARTNER_DISABLED_URL)
            }, 300)
          }

          return null
        }

        if (!silent) {
          const rawErrorMessage = Array.isArray(err)
            ? err
            : err?.payload?.message || err?.message || err

          const errorMessage = formatApiErrorMessage(rawErrorMessage)

          snackbar?.enqueueSnackbar(errorMessage, { variant: 'error' })
        }

        return null
      }
    },
    [platform],
  )

  return { asyncDispatchWithErrorToast }
}
